<template>
  <div>
    <div class="footer-container">
      <div class="container flex">
        <div class="left">
          <img src="/img/2公司介绍-logo.png" alt="">
          <div class="leftDesc">{{$t('footer.slogan1')}}</div>
          <div class="leftDesc">{{$t('footer.slogan2')}}</div>
          <div class="leftTitleBox">
            <div class="leftTitle">{{$t('footer.companyFullName')}}</div>
          </div>
        </div>
        <div class="center">
          <h2 class="title">{{ $t('footer.productScope') }}</h2>
          <div class="scope">
            <div class="scoped-item">
              <div
                  v-for="(item, index) in scoped1"
                  :key="index"
                  @click="toProduct"
              >
                {{ item }}
              </div>
            </div>
            <div class="scoped-item">
              <div
                  v-for="(item, index) in scoped2"
                  :key="index"
                  @click="toProduct"
              >
                {{ item }}
              </div>
            </div>
            <div class="scoped-item">
              <div
                  v-for="(item, index) in scoped3"
                  :key="index"
                  @click="toProduct"
              >
                {{ item }}
              </div>
            </div>
            <div class="scoped-item">
              <div
                  v-for="(item, index) in scoped4"
                  :key="index"
                  @click="toProduct"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <h2 class="title">{{ $t('footer.contactTitle') }}</h2>
          <div>
            <img src="/img/1首页-bottom-icon2.png" alt="phone" />
            <span>0579-85541088</span>
          </div>
          <div>
            <img src="/img/1首页-bottom-icon1.png" alt="email" />
            <span>liming@kmt-style.net</span>
          </div>
          <div>
            <img src="/img/1首页-bottom-icon3.png" alt="address" />
            <span>{{ address }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
<!--      {{ $t('footer.copyright') }}-->
    </div>
  </div>
</template>

<script>
import { t } from '@/VueI18n'

export default {
  name: 'Footer',
  data() {
    return {
      scoped1: [
        t('footer.kitchenware'),
        t('footer.bathroom'),
        t('footer.daily'),
        t('footer.stationery')
      ],
      scoped2: [
        t('footer.bikeParts'),
        t('footer.electronics'),
        t('footer.antiSlip'),
        t('footer.car')
      ],
      scoped3: [
        t('footer.knitting'),
        t('footer.detergent'),
        t('footer.hardware'),
        t('footer.tablecloth')
      ],
      scoped4: [
        t('footer.petSupplies'),
        t('footer.plasticGoods')
      ],
      address: t('footer.address')
    }
  },
  watch: {
    '$i18n.locale'() {
      this.updateText()
    }
  },
  mounted() {
    this.updateText()
  },
  methods: {
    toProduct() {
      this.$router.push('/productDisplay')
      sessionStorage.setItem('index', 4)
      this.$emit('update:currentIndex', 4)
    },
    updateText() {
      this.scoped1 = [
        t('footer.kitchenware'),
        t('footer.bathroom'),
        t('footer.daily'),
        t('footer.stationery')
      ]
      this.scoped2 = [
        t('footer.bikeParts'),
        t('footer.electronics'),
        t('footer.antiSlip'),
        t('footer.car')
      ]
      this.scoped3 = [
        t('footer.knitting'),
        t('footer.detergent'),
        t('footer.hardware'),
        t('footer.tablecloth')
      ]
      this.scoped4 = [
        t('footer.petSupplies'),
        t('footer.plasticGoods')
      ]
      this.address = t('footer.address')
    }
  },
}
</script>

<style scoped lang="scss">
.footer-container {
  min-width: 1440px;
  background-color: var(--bg-color);
}
.container {
  min-width: 1440px;
  justify-content: center;
  padding-top: 40px;
  height: 340px;
  max-width: 1900px;
}
.left {
  font-size: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 20px;
  margin-right: 10px;
  width: 500px;
  flex-shrink: 0;
  img {
    height: 40px;
    margin-bottom: 4px;
  }
  .leftDesc {
    font-size: 20px;
    padding-left: 28px;
    margin-bottom: 2px;
  }
  .leftTitleBox {
    padding-left: 28px;
    .leftTitle {
      margin-top: 40px;
      font-size: 18px;
      color: white;
      background: black;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 4px 10px;
      border-radius: 2px;
      letter-spacing: 2px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 470px;
    }
  }

}
.center {
  height: 202px;
  margin-right: 10px;
  flex-shrink: 0;
  flex-grow: 1;
}
.title {
  margin-bottom: 40px;
  font-size: 20px;
  color: #333;
}
.right {
  width: 350px;
  flex-shrink: 0;
  div {
    display: flex;
    align-items: center;
    color: #101010;
    img {
      margin-right: 29px;
    }
    &:nth-child(3) {
      margin: 20px 0;
    }
  }
}
.footer {
  text-align: center;
  line-height: 60px;
  background-color: #eaeaea;
}
.scope {
  display: flex;
  justify-content: space-between;
}
.scoped-item {
  margin-right: 10px;
  div {
    margin-bottom: 15px;
    cursor: pointer;
    white-space: nowrap;
  }
}
</style>